<template>
	<input type="text" class="form-control" :value="handler" @input="mask" :required="required" />
</template>

<style scoped></style>
<script>
export default {
	props: ["value", "type", "required"],
	data() {
		return {
      handler:'',
		};
	},
	watch:{
		value:{
			handler:function(val,oldval){
				if(!val) return;
				if (this.type=='email_link') {
					this.handler = val.replace(/mailto:/,'');
				}else	if (this.type=='telephone_link') {
					this.handler = val.replace(/tel:/,'');
				}else if (this.type=='whatsapp_link') {
					this.handler = val.replace(/https:\/\/wa.me\//,'');
				} else {
					this.handler = val;
				}
			},
			immediate:true
		}
	},
	methods: {
		mask: function(e) {
			var input = e.target.value;

			if (this.type=='email_link') {
					input = 'mailto:'+input;
			}
			if (this.type=='telephone_link') {
					input = input.replace(/[^\d]/g,'');
					input = 'tel:'+input;
			}
			if (this.type=='whatsapp_link') {
				input = input.replace(/[^\d]/g,'');
				if(input.length<12 && !input.match(/^55/)){
					input = '55'+input;
				}
				input = 'https://wa.me/'+input;
			}

			this.$emit("input", input);
		}
	},

};
</script>
